module.exports = __webpack_public_path__ + "static/sh-6560d76bf10093362d933d31d620b17f.svg";